export const mapCategoryToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfDevice: item.devices?.length || 0,
  }));

  return result;
};

export const showHomeScreen = [
  {
    id: "show",
    name: "Show",
  },
  {
    id: "hide",
    name: "Hide",
  },
];

export const categoryColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "rogoDevTypeCode", label: "RogoDevTypeCode", align: "center" },
  { key: "rogoDevTypeStr", label: "RogoDevTypeStr", align: "center" },
  { key: "numOfDevice", label: "Num Of Device", align: "center" },
];
